module.exports = __webpack_public_path__ + "static/img/hc.00433019.png";